import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold" }, "All Records", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = { class: "space-y-5" }
const _hoisted_5 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }

import { ref } from "vue";

import DataTable from '@/components/partials/DataTable.vue';
import FilterPanel from '@/components/partials/FilterPanel.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import SelectOptions from "@/components/inputs/SelectOptions.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogsTable',
  props: {
    items: {
        type: Object,
        defualt: [],
        required: true,
    },
},
  setup(__props) {

const props = __props;


const headers: { text: string, haveSort?: boolean }[] = [
    { text: 'ID' },
    { text: 'Subject'},
    { text: 'Description' },
    { text: 'Caused By' },
    { text: 'Date Created' },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTable, {
    headers: headers,
    noAction: "",
    count: __props.items.total,
    hasSearch: true,
    searchPlaceholder: "Search Activity",
    tableClass: "header-frm-table",
    dataTableClass: "border-0"
  }, {
    topContent: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFilter = true))
        }, _hoisted_3),
        _createVNode(FilterPanel, {
          show: _ctx.showFilter,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilter = false)),
          "onApply:reset": _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyReset())),
          "onApply:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.applyFilters()))
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(DatePicker, {
                id: "date_created",
                name: "date_created",
                label: "Date Created",
                range: true
              })
            ])
          ]),
          default: _withCtx(() => [
            _createTextVNode(" > ")
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    body: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.data, (item) => {
        return (_openBlock(), _createElementBlock("tr", { key: item }, [
          _createElementVNode("td", _hoisted_5, _toDisplayString(item.id), 1),
          _createElementVNode("td", _hoisted_6, _toDisplayString(item.event), 1),
          _createElementVNode("td", _hoisted_7, _toDisplayString(item.description), 1),
          _createElementVNode("td", _hoisted_8, _toDisplayString(item.causer_name), 1),
          _createElementVNode("td", _hoisted_9, _toDisplayString(item.created_at_formatted), 1)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["count"]))
}
}

})